module.exports = __webpack_public_path__ + "static/project-main-edi-61e181c7e0252d0b29ea82c93222ed30.jpg";